import { getConstant } from '../utils';

export const getCalculatorsYear = getConstant('GET_CALCULATORS_YEAR');
export const getCalculatorsYearItem = getConstant('GET_CALCULATORS_YEAR_ITEM');